import { find } from 'lodash';
import { BlockData } from '../RbKit';

export const getValue = (data: BlockData, id: string): any => {
    const field = find(data.fields, { id });
    return field ? field.value : undefined;
}
